/**
 * Verifies whether it is one day or multiple days and concats the number of days with 'day' or 'days'.
 *
 * @param days
 * @returns - Formatted string (ie: '3 days' or '1 day')
 */
export function numberOfDays(days: number | undefined): string {
    if (!days) {
        return '0 days';
    }

    if (days > 1 || days === 0) return `${days} days`;

    return `${days} day`;
}
